import AddIcon from "@mui/icons-material/Add";
import { IconButton } from "@mui/material";
import { useCallback } from "react";
import { useDialogBetter } from "../../../hooks/useDialogBetter";
import {
    EmailFooterConfigurationDialog,
    EmailFooterConfigurationDialogMode,
} from "./EmailFooterConfigurationDialog";

export const CreateEmailFooterButton = (props) => {
    const { sellerId, onSuccess } = props;
    const { openDialog } = useDialogBetter();

    const handleClick = useCallback(
        () =>
            openDialog({
                Component: EmailFooterConfigurationDialog,
                componentProps: {
                    sellerId,
                    onSuccess,
                    mode: EmailFooterConfigurationDialogMode.CREATE,
                },
            }),
        [openDialog, sellerId, onSuccess],
    );

    return (
        <IconButton onClick={handleClick}>
            <AddIcon />
        </IconButton>
    );
};
